// Globals
import { useTranslation } from 'react-i18next';

// Models
import { Action, IBaseActionLog } from '@/models/logs.model';
import { StyledText } from './PropertyActionStateStyles';

// Helpers
import { getCountDiff } from '../../helpers';

type TPropertyActionStateProps = {
  log: IBaseActionLog;
};

export const PropertyActionState = ({ log }: TPropertyActionStateProps) => {
  const { t } = useTranslation('logs');
  switch (log.action) {
    case Action.ORDER_STATUS_UPDATED:
      return (
        <StyledText>
          {t(`property_logs_status_${log.action}`, {
            context: log.diff?.new?.status,
            step: log.step_name,
          })}
        </StyledText>
      );

    case Action.PROPERTY_DATA_AMENDED:
      const bra_label = t('property_logs_status_property_data_amended_bra');
      const property_type_label = t('property_logs_status_property_data_amended_property_type');

      return (
        <StyledText>
          {t(`property_logs_status_${log.action}`, {
            before: `${bra_label}: ${log.diff?.old?.bra || '-'},\n${property_type_label}: ${
              log.diff?.old?.property_type || '-'
            }`,
            after: `${bra_label}: ${log.diff?.new?.bra || '-'},\n${property_type_label}: ${
              log.diff?.new?.property_type || '-'
            }`,
          })}
        </StyledText>
      );

    default:
      return (
        <StyledText>
          {t(`property_logs_status_${log.action}`, {
            context: log.step_name,
            step: log.step_name,
            count: getCountDiff(log.diff?.old?.photos_count ?? 0, log.diff?.new?.photos_count ?? 0),
          })}
        </StyledText>
      );
  }
};
